// @ts-check
import React, { createContext, useMemo, useCallback, useContext } from 'react';

/**
 * PillTabContext.
 */

/** @typedef {{
  activeTab: string;
  setTab(tab: string): void;
}} PillTabCtx */

/** @type { React.Context<PillTabCtx | null> } */
const PillTabContext = createContext(null);

/**
 * PillTab.
 */

/** @typedef {{
  tab: string
}} PillTabProps */

/** @type { React.FC<PillTabProps> } */
export const PillTab = (props) => {
  const { tab, children } = props;
  const { activeTab, setTab } = useContext(PillTabContext);
  const isActive = activeTab === tab;

  const activeClassName = isActive
    ? 'bg-indigo-100 text-indigo-700 shadow-inner'
    : 'text-gray-500 hover:text-gray-700';

  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive ? 'true' : 'false'}
      id={tab}
      onClick={() => setTab(tab)}
      className={`${activeClassName} border-0 px-3 py-2 font-medium text-sm rounded-md`}
    >
      {children}
    </button>
  );
};

/**
 * PillTabs.
 */

/** @typedef {{
  activeTab: string;
  onChange(tab: string): void;
  children: React.ReactElement<PillTabProps>[];
}} PillTabsProps */

/** @type { React.FC<PillTabsProps> } */
export const PillTabs = (props) => {
  const { activeTab, onChange, children } = props;

  const handleTabClick = useCallback(
    (tab) => {
      onChange(tab);
    },
    [onChange]
  );

  const ctx = useMemo(
    () => ({
      activeTab,
      setTab: handleTabClick,
    }),
    [activeTab, handleTabClick]
  );

  // const tabOptions = Children.map(children, (child) => {
  //   if (isValidElement(child)) {
  //     return {
  //       value: child.props.tab,
  //       label: child.props.children,
  //     };
  //   }
  //   return null;
  // }).filter(Boolean);

  return (
    <PillTabContext.Provider value={ctx}>
      <div>
        {/* <div className="sm:hidden">
          <label htmlFor="pillTabs" className="sr-only">
            Select a tab
          </label>
          <InputSelect
            id="pillTabs"
            name="pillTabs"
            value={activeTab}
            onChange={handleTabClick}
            options={tabOptions}
          />
        </div> */}
        <div>
          <nav className="flex space-x-2" aria-label="Tabs">
            {children}
          </nav>
        </div>
      </div>
    </PillTabContext.Provider>
  );
};
